import { ICancerRejection } from './cancer-rejection';
import { ICancerRejectionList } from './cancer-rejection-list';
import { IKidneyStoneRejection } from './kidney-stone-rejection';

export interface IReferralConfig {
    centerId: number,
    isRegistrationEnabled: boolean,
    useQuickStart: boolean,
    useAdpDefaults: boolean,
    useReducedQuestions: boolean,
    useCystatinC: boolean,
    offerDonorConnect: boolean,
    donorConnectGroup: number,
    offerRuleOutTransfer: boolean,
    isDonorConnectLiverEnabled: boolean,
    isDonorConnectNegC: boolean,
    referDonorToNkr: boolean,
    askSexualSocialQuestions: boolean,
    askForId: boolean,
    doRealTimeEval: boolean,
    callbackBusinessDays: string,
    dashDonorDaysToExpire: number,
    yearsForFollowUpLabs: number,
    recipientMaxAge: string,
    donorMaxAge: string,
    intakeWorkflowConfig: number,
    dashDonorDaysToExpireText: string,
    dashUsesPwlQuest: boolean,
    dashUsesLiverPwl: boolean,
    isDashLiverParticipant?: boolean,
    dashUsesPwlPhlebot: boolean,
    dashUsesPwlAtMiles: number,
    dashUsesFiveStar: boolean,
    usesPwlForNdd: boolean,
    usesPwlForAdp: boolean,
    usesPwlForLongDistanceDonors: boolean,
    bmiLimit: string,
    bmiRequiredForSurgery: string,
    bmiLimitLiver: string,
    bmiRequiredForSurgeryLiver: string,
    minAgeNdd: string,
    minAgeDd: string,
    mustAcceptBloodTransfusions: boolean,
    ruleOutOnGestationalDiabetes: boolean,
    ruleOutOnKidneyDisease: boolean,
    ruleOutOnHiv: boolean,
    alwaysRuleOutOnHeartAttack: boolean,
    requireQuitTobacco: boolean,
    heartAttackRemissionRequired: number,
    diabetesFailLevel: number,
    plDashPhoneNumber: string,
    plDashPhoneIsDisplayed: boolean,
    ruleOutOnPregnancy: boolean,
    ruleOutOnPregnancyWaitTime: number,
    ruleOutOnNursing: boolean,
    liverRuleOutLiverDisease: boolean,
    liverRuleOutKidneyDisease: boolean,
    liverRuleOutHepB: boolean,
    liverRuleOutHepC: boolean,
    liverRuleOutDiabetes: boolean,
    liverDonorMaxAge: string,
    expertSystemAutomated: boolean,
    followUpKitId: number,
    followUpAllowPhlebot: boolean,
    expireToQueuePostScreening: boolean,
    isFamilyVoucherLinkOption: boolean,
    isStandardVoucherLinkOption: number,
    preWorkupLabConfig: number,
    referralSources: string[],
    cancerRejection: ICancerRejection[];
    cancerRejectionList: ICancerRejectionList[];
    kidneyStoneRejection: IKidneyStoneRejection[];
    cancerRejectionJson: string;
    kidneyStoneRejectionJson: string;
    kidneyStoneRejectionList: IKidneyStoneRejectionItem[];
}

export interface IKidneyStoneRejectionItem {
    index: number,
    value: number
}
